import PriorityChip, { type PriorityTypes } from '@/components/PriorityChip';

import { dateFormatter, ticketTypeFormatted } from './DashboardInternal.utils';

export const ticketsTableColumns = [
  { field: 'id', headerName: 'ID', width: 75 },
  {
    field: 'ticket_type',
    headerName: 'Type',
    width: 85,
    renderCell: (params: { row: { ticket_type: number } }) => {
      const ticketType = ticketTypeFormatted(params.row.ticket_type);
      return <div>{ticketType}</div>;
    }
  },
  { field: 'title', headerName: 'Title', width: 200, flex: 1, minWidth: 200 },
  { field: 'organization_name', headerName: 'Organization', width: 200 },
  {
    field: 'priority_name',
    headerName: 'Priority',
    width: 75,
    renderCell: (params: { row: { priority_name: string } }) => (
      <PriorityChip priority={params.row.priority_name as PriorityTypes} />
    )
  },
  { field: 'owner_name', headerName: 'Owner', width: 150 },
  { field: 'external_ticket_id', headerName: 'Jira Ticket', width: 170 },
  {
    field: 'team_queue',
    headerName: 'Team Queue',
    width: 125
  },
  {
    field: 'created_at',
    headerName: 'Created At',
    width: 175,
    renderCell: (params: { row: { created_at: string } }) =>
      dateFormatter(params.row.created_at)
  },
  {
    field: 'follow_up_date',
    headerName: 'Follow Up Date',
    width: 175,
    renderCell: (params: { row: { followup_date: string } }) =>
      dateFormatter(params.row.followup_date)
  },
  {
    field: 'updated_at',
    headerName: 'Updated At',
    width: 175,
    renderCell: (params: { row: { updated_at: string } }) =>
      dateFormatter(params.row.updated_at)
  }
];

export const TEAM_QUEUE_COLUMNS = [
  {
    name: 'Team Queue',
    field: 'teamQueue',
    id: 1,
    headerName: 'Team Queue',
    width: 200,
    flex: 1,
    minWidth: 175,
    renderCell: (params: { row: { teamQueue: string } }) => (
      <div
        style={{
          paddingTop: window.location.pathname.includes('dashboard')
            ? ''
            : '0.5rem'
        }}
      >
        {params.row.teamQueue}
      </div>
    )
  },
  {
    name: 'Open',
    field: 'open',
    id: 2,
    headerName: 'Open',
    renderCell: (params: { row: { open: number } }) => (
      <div className="openTickets">{params.row.open}</div>
    )
  },
  {
    name: 'Next Action Owner',
    field: 'nextActionOwner',
    id: 3,
    headerName: 'Next Action Owner',
    width: 200,
    renderCell: (params: { row: { nextActionOwner: string } }) => (
      <div className="nextActionOwnerTickets">{params.row.nextActionOwner}</div>
    )
  },
  {
    name: 'Due Now',
    field: 'dueNow',
    id: 4,
    headerName: 'Due Now',
    renderCell: (params: { row: { dueNow: number } }) => (
      <div className="dueNowTickets">{params.row.dueNow}</div>
    )
  },
  {
    name: 'Past Due',
    field: 'pastDue',
    id: 5,
    headerName: 'Past Due',
    renderCell: (params: { row: { pastDue: number } }) => (
      <div className="pastDueTickets">{params.row.pastDue}</div>
    )
  },
  {
    name: 'Risky Tickets',
    field: 'riskyTickets',
    id: 6,
    headerName: 'Risky Tickets',
    width: 200,
    renderCell: (params: { row: { riskyTickets: number } }) => (
      <div className="riskyTickets">{params.row.riskyTickets}</div>
    )
  }
];

export default ticketsTableColumns;
